import dynamic from 'next/dynamic';
const CircleButton = dynamic(() => import('./CircleButton'));

export default CircleButton;
